import { magicMfaVerifySchema, magicLinkSignedInSchema } from "@io-spoke/contracts/magicLinks";
import { getApiClient } from "./apiClient";

/** Returns canonical authentication only; the active challenge owner decides whether to store it. */
export async function verifyMagicMfa(session: string, code: string) {
  const request = { skipAuthRefresh: true, headers: { "Content-Type": "application/json" } };
  const response = await getApiClient().post("/auth/magic/mfa/verify", magicMfaVerifySchema.parse({ session, code }), request);
  return magicLinkSignedInSchema.parse(response.data);
}
